import { EventEmitter, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { IHttpSuccessPayload } from '@core/models';
import { HttpProviderService, HttpRequest } from '@fpx/core';
import { HttpRequestPayload, IHttpErrorPayload } from '@fpx/core';
import { BehaviorSubject, catchError, map, Observable, of, Subject, throwError } from 'rxjs';
import { DialogService } from 'src/app/fpx-core/services/dialog/dialog.service';
import { environment } from 'src/environments/environment';
import { IProcessInfo, IProcessShellRouterInfo, IResultIconData } from '../models/process-shell.model';
import { UserService } from "../../user.service";
import { CommonService } from 'src/app/common.service';
import { IPopupScreenData } from 'src/app/common/models/popup-screen-data.model';
import { InfoPopupComponent } from 'src/app/core/components/popup/info-popup/info-popup.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CustomerService } from 'src/app/services/customer.service';

@Injectable({
  providedIn: 'root'
})
export class ProcessShellService {
  formClassName: string = "";
  processTitle: string = "";
  processCompleted: string | number = 20;
  processCode: string = "";
  processId: string = "";
  stageCode: string = "";
  progressBarVisible: boolean = false;
  formComponent: any;
  isFormValid: boolean = false;
  popup: boolean = false;
  isFormSubmitted: boolean = false;
  isResultPage: boolean = false;
  closeNavigation: string[];
  backNavData: any[] = [];
  cobData: any = {};
  formType: '1' | '2' = '2';
  preSubmitFormEmit: EventEmitter<any>;
  selectProd: any;

  private _footerVisible: boolean = true;
  private _shellRoutingParams: any;
  private _formValidStatus$: Subject<boolean> = new Subject<boolean>();
  private _formSubmittedCompleteStatus$: Subject<any> = new Subject<any>();
  processInfo: IProcessInfo;
  updatedProcessInfo: boolean;
  userName: string;

  private draftProcess: any[] = [];
  submitBtnText: string = 'Processing';
  resultIconData: IResultIconData[];
  resultIconClick: EventEmitter<any>;
  private _backBtnVisible: boolean = true;
  private samePageRoutingModule: string[] = ['cc-flash', 'dc-flash'];
  private anotherPageRoutingModule: string[] = ['pfm-category'];
  private otpPageSpecialCaseRoutingModule: string[] = ['open-new-ca', 'open-new-sa', 'deposit-request-form', 'change-maturity-instruction', 'change-pin', 'dc-unblock', 'replacement-card', 'dc-services', 'limit-increase', 'dc-status','dc-request'];
  public _confirmationEnable: boolean = false;
  public isConfirmationClicked: boolean = false;
  twoFactor: any = {};
  isCustomerRefreshRequired: boolean;

  public currentStage: string = "";
  autoLogOutRequired: boolean;
  private _headerBackBtnVisible: boolean = true;

  public formData: any;

  constructor(
    private _customerService: CustomerService,
    private _http: HttpProviderService,
    private _router: Router,
    public _dialogService: DialogService,
    private _userService: UserService,
    private _commonService: CommonService,
    private dialogRef: MatDialogRef<InfoPopupComponent>,
    private _dialog: MatDialog,
  ) { }


  initializeProcessShell() {
    if (this._shellRoutingParams) {
      this.processCode = this._shellRoutingParams.processCode || this.processCode;
      this.processTitle = this._shellRoutingParams.processTitle;
      this.formType = this._shellRoutingParams.formType || '2';
    }

    if (this.formType == '1') {
      this.formClassName = "onboarding-form";
      this.closeNavigation = ['welcome'];
      this.popup = true;
      this.setProgressBarVisible(true);
    } else {
      this.formClassName = "";
      this.popup = false;
      this.setProgressBarVisible(false);
    }

    this._formValidStatus$ = new Subject<boolean>();
    this.getFormValidStatus().subscribe((res) => {
      this.isFormValid = res;
    });

    this._formSubmittedCompleteStatus$ = new Subject<any>();
    this.getFormSubmittedCompleStatus().subscribe((res) => {
      let currentStageIndex = this.processInfo?.stageInfo.findIndex(obj => { return obj.stageCode == this.stageCode });
      let stageInfo;
      if (currentStageIndex > 0) stageInfo = this.processInfo?.stageInfo[currentStageIndex + 1];
      if (this.processInfo && stageInfo) {
        stageInfo = this.processInfo.stageInfo[this.processInfo.stageInfo.findIndex(obj => { return obj.stageCode == this.stageCode }) + 1];
        let routingParams = stageInfo.stageUIConfig.routingParam ? ((typeof (stageInfo.stageUIConfig.routingParam) === 'string') ? JSON.parse(stageInfo.stageUIConfig.routingParam) : stageInfo.stageUIConfig.routingParam) : {};
        this.setTitle(stageInfo.stageUIConfig.title);
        this.processCompleted = stageInfo.stageCompletionPercentage;
        let path = (stageInfo.stageUIConfig.navigationPath) ? stageInfo.stageUIConfig.navigationPath.split('/') : '';
        let routerPath = ['process-shell'].concat(path);

        routingParams['action'] = 'MODIFY';
        routingParams['processId'] = this.processId;
        routingParams['currentStage'] = this.stageCode = stageInfo.stageCode;
        routingParams['response'] = this.processInfo.processPayload.COB[stageInfo.stageCode];

        this.navToResult(routerPath, routingParams)

      }
      else this.fetchProcessInstance(res);
    });

  }

  clearDataForFailureEnd(routingParams) {
    if (routingParams.currentStage == "FailureEnd") {
      this.resultIconData = undefined;
      this.isCustomerRefreshRequired = false;
      this.autoLogOutRequired = false;
    }
  }

  navToResult(routerPath, routingParams) {
    // Desktop post login
    let currentRoutePath = this._router.url.split('/');
    let nextRoute;

    //if failure end, clear unwanted fields
    this.clearDataForFailureEnd(routingParams);

    if (this.samePageRoutingModule?.includes(routerPath?.[routerPath?.length - 1]) && routingParams.currentStage != "FailureEnd") {
      nextRoute = currentRoutePath;
    }
    if (this.anotherPageRoutingModule?.includes(currentRoutePath?.[currentRoutePath?.length - 1]) && routingParams.currentStage != "FailureEnd") {
      if (this._shellRoutingParams?.additionalDetails?.backNav?.includes('process-shell')) {
        nextRoute = routerPath
      } else {
        routerPath?.shift()
        nextRoute = routerPath
      }
    }
    if (this.closeNavigation?.length > 0) {
      routingParams['backNavPath'] = this.closeNavigation
    }


    //temp fix for refresh customer api start
    try {
      if (this.isCustomerRefreshRequired && !(this.currentStage=='CREATEOTP' || this.currentStage=='VERIFYOTP')) {
        this.isCustomerRefreshRequired = false;
        this._customerService?.fetchCustomerInfo('')?.subscribe((res) => {
        })
      }
    } catch (err) {

    }
    //temp fix for refresh customer api end
    console.log('routingParams -------> ',routingParams)

    if (this.formType != '1' && this._commonService.isDesktop()) {

      if (!nextRoute) {
        // Pop-Up [result-page ]

        // let resultRouteLastPath = this.getResultLastPath(routerPath?.[routerPath?.length - 1])
        // this._dialogService.open({
        //   component: resultRouteLastPath,
        //   data: routingParams,
        //   panelClass: 'result-page-dialog'
        // });

        //New screen [result-page]
        let currentBasepath = this._router.url.split('/')[2];
        routerPath = ['home', currentBasepath].concat(routerPath);

        // if(!this.test && routerPath[routerPath.length-1]=="verify-otp"){
        //   routerPath[routerPath.length-1] = 'create-otp';
        //   this.test = true;
        // }
        this._router.navigate(routerPath,{
            queryParams: routingParams,
            queryParamsHandling: 'preserve'
          });
        return;
      }
      this._router.navigate(nextRoute, {
        queryParams: routingParams,
        queryParamsHandling: 'preserve'
      });
      return;
    }

    if (this.formType == '1' && this._commonService.isDesktop()) {
      routerPath.unshift('onboarding');
    }
    this._router.navigate(nextRoute ? nextRoute : routerPath, {
      queryParams: routingParams,
      queryParamsHandling: 'preserve'
    });
  }

  test;

  navToOtpChannelOrVerifOtp(routingParams){
    let currentRoutePath = this._router.url.split('/');
    let routerPath = [];
     if (this.formType != '1' && this._commonService.isDesktop()) {
      if (this.otpPageSpecialCaseRoutingModule?.includes(currentRoutePath?.[currentRoutePath?.length - 1])) {
        let currentBasepath = this._router.url.split('/')[2]
        routerPath = ['home', currentBasepath].concat(routerPath);
      } else {
        let currentBasepath = routerPath[routerPath.length - 2];
        routerPath = ['home', currentBasepath].concat(routerPath)
      }
    }
    this._router.navigate( routerPath, {
      queryParams: routingParams,
      queryParamsHandling: 'preserve'
    });
  }

  onAfterFormInit(formCtrl: any) {
    this.formComponent = formCtrl;
    this.isFormSubmitted = false;
    this._footerVisible = true;
    this._commonService.isbackBtn = true;
    this._headerBackBtnVisible = true;
    let shellRouterData = this._router.getCurrentNavigation()?.extras?.queryParams;
    this.setShellRoutingParams(shellRouterData);
    this.updateShell();
    if (shellRouterData?.additionalDetails?.backNavData) {
      this.pushBackNav(shellRouterData?.additionalDetails?.backNavData)
    }

    if (this.formComponent.formGroup) {
      if (this.formType == '1') {
        this.formComponent.addFormControl('appRef', this.processId, []);
      }
      this.formComponent.formGroup.valueChanges.subscribe((value) => {
        this.triggerFormValidStatus(this.formComponent.formGroup.valid);
      });
    }
  }

  setTwoFactor(response){
    if (response?.success?.body && typeof response?.success?.body == 'object' && Object?.values(response?.success?.body)?.[0]?.['twoFactor']) {
      this.twoFactor = Object?.values(response?.success?.body)?.[0]?.['twoFactor']
    } else  if (response?.body && typeof response?.body == 'object' && Object?.values(response?.body)?.[0]?.['twoFactor']) {
      this.twoFactor = Object?.values(response?.body)?.[0]?.['twoFactor']
    }else {
      this.twoFactor = {}
    }
  }

  fetchProcessInstance(response: any) {
    const httpRequest = new HttpRequest();

    this.setTwoFactor(response)
    //twofactor setup

    httpRequest.setResource('/processinstance/{processCode}/{processId}');
    httpRequest.addPathParameter('processCode', this.processCode);
    httpRequest.addPathParameter('processId', this.processId);
    httpRequest.setMethod('GET');
    httpRequest.setServerContext(environment.commonPublisher);

    return this._http.invokeRestApi(httpRequest).subscribe(
      {
        next: (routerInfo: any) => {
          this.draftProcess.push({
            queryParams: this.getShellRoutingParams()
          });
          let processInstance: IProcessShellRouterInfo = routerInfo?.body.processinstance;
          this.currentStage = processInstance?.currentStage;

          if (Object.keys(processInstance).length === 0 && this.formType == '1') {
            this.onApiError();
            return;
          }

          let params = (typeof (processInstance.routingParam) === 'string') ? JSON.parse(processInstance.routingParam) : processInstance.routingParam;
          this.setTitle(processInstance.title);
          this.processCompleted = processInstance.completionPercentage;
          let path = (processInstance.navigationPath) ? processInstance.navigationPath.split('/') : '';
          let routerPath = ['process-shell'].concat(path);

          let routingParams = {
            ...params,
            response: response || null
          }

          let stage = processInstance?.currentStage?.toUpperCase();
          if (stage == 'SUCCESSEND' || stage == "FAILUREEND") {
            routingParams['processId'] = this.processId;
            this.stageCode = processInstance.currentStage
            routingParams['currentStage'] = processInstance.currentStage;
            if (processInstance.navigationPath) {
              let backNavPath = processInstance.navigationPath.split('/')
              routingParams['backNavPath'] = backNavPath[0];
            }
          } else if(stage == 'BOAPPROVAL'){
            let dialogData = {
              result: 'warning',
              title: 'Thank you for initiating your application',
              message: "Please visit your nearest branch with your valid ID to complete the process and pick up your VISA Debit Card",
              button: ['Close']
            }
            this._dialogService.open({
              component: "alert",
              data: dialogData,
              closeFn: (res) => this.onCloseApprovalDialog(res)
            })
          }
          else {
            routingParams['currentStage'] = processInstance.currentStage;
            this.stageCode = processInstance.currentStage;
          }

          if (processInstance.currentStage == 'VerifyOTP' || processInstance.currentStage == 'VerifySMSOTP'){
            if(this.processCode == "COB"){
              routingParams['currentStage'] = "ContactInfo";
            }
            this.submitBtnText = 'Validating';
          }
          else this.submitBtnText = 'Processing';
          this.backNavData = [];
          routingParams['navigationPath'] = processInstance.navigationPath
          if(processInstance.currentDateTime){
            routingParams['currentDateTime'] = processInstance.currentDateTime
          }

          this.navToResult(routerPath, routingParams);
        },
        error: () => { },
        complete: () => { }
      }
    );
  }

  setShellRoutingParams(params: any) {
    try {
      if (this.formComponent) this.formComponent.setRoutingParam(params);
    } catch (reason) {

    }

    this._shellRoutingParams = params;

    if (this.formType == '1') {
      this.formClassName = "onboarding-form";
      this.closeNavigation = ['welcome'];
      this.popup = true;
      this.setProgressBarVisible(true);
    } else {
      this.setProgressBarVisible(false);
    }
  }
  getShellRoutingParams(): any {
    return this._shellRoutingParams;
  }
  clearShellRoutingParams() {
    this._shellRoutingParams = null;
  }

  setProgressBarVisible(visible: boolean) {
    this.progressBarVisible = visible;
  }

  /**
   * Process shell footer visible getter, setter
   * @param visible
   */
  setFooterVisible(visible: boolean = true) {
    this._footerVisible = visible;
  }
  getFooterVisible(): boolean {
    return this._footerVisible;
  }

  /**
   * Process shell footer visible getter, setter
   * @param visible
   */

  /**
   * Process shell HEADER visible getter, setter START
   * @param visible
   */
  setHeaderBackbtnVisible(visible: boolean = true) {
    this._headerBackBtnVisible = visible;
    if(!visible){
      this._commonService.isbackBtn = false;
    }
  }
  getHeaderBackbtnVisible(): boolean {
    return this._headerBackBtnVisible;
  }

  /**
   * Process shell HEADER visible getter, setter END
   * @param visible
   */


  setConfirmationPage(visible: boolean = true) {
    this._confirmationEnable = visible;
  }
  getConfirmationPage(): boolean {
    return this._confirmationEnable;
  }

  //ONLY FOR ONBOARDING START
  setBackbtnVisible(visible: boolean = true) {
    this._backBtnVisible = visible;
    if(this._commonService.isDesktop){
      this._commonService.isbackBtn = visible;
    }
  }

  isBackBtnAvailable(): boolean {
    return this._backBtnVisible;
  }
   //ONLY FOR ONBOARDING END

  setTitle(title: string) {
    this.processTitle = title;
    this._commonService.serviceDescription = title;
  }

  triggerFormValidStatus(val) {
    this._formValidStatus$.next(val);
  }
  getFormValidStatus(): Observable<boolean> {
    return this._formValidStatus$;
  }

  triggerFormSubmittedCompleteStatus(val) {
    if (val?.error) {
      let message = (val?.error?.error?.ErrorDescription) ? val?.error?.error?.ErrorDescription : "Look's like there is a technical difficulty while reaching the servers. Please try again.";
      let baseRouteArray = this._router?.url?.split('/');
      let baseRoute = baseRouteArray[baseRouteArray?.length - 2]
      //reset start
      this.stageCode = 'FailureEnd'

      this.clearDataForFailureEnd({currentStage : "FailureEnd"})
      //reset end
      let routingParams = { backNavPath: baseRoute ? baseRoute : '', currentStage: "FailureEnd", message: message }
      setTimeout(() => {
        this.navToResult(['process-shell', baseRoute ? baseRoute : '', 'result-info'], routingParams)
        // this._router.navigate(['process-shell',baseRoute?baseRoute:'','result-info'],{
        //   queryParams: routingParams,
        //   queryParamsHandling: 'preserve'
        // })
      }, 200);
    } else {
      this._formSubmittedCompleteStatus$.next(val);
    }
  }
  getFormSubmittedCompleStatus(): Observable<any> {
    return this._formSubmittedCompleteStatus$;
  }

  navigateTo(path: string[], queryParams: any = {}) {
    this._router.navigate(path, {
      queryParams: queryParams,
      queryParamsHandling: 'preserve'
    });
  }
  onApiError() {
    let CBXDialogData = {
      result: 'failure',
      title: 'Something went wrong',
      message: "Sorry we couldn't able to fetch data from your document at this time",
      button: ['Close']
    }
    this._dialogService.open({
      component: 'alert',
      data: CBXDialogData,
      closeFn: (res) => this.onCloseDialog(res)
    })
  }
  onCloseProcess() {
    if (!this._userService.getToken()) { this._router.navigate(['welcome']); return; }
    let CBXDialogData = {
      result: 'success',
      title: 'Abort Application',
      refNum: this.processId,
      message: "Do you really want to abort this process? But don't worry you can resume anytime using this below reference number",
      button: ['Cancel', 'OK']
    }
    this._dialogService.open({
      component: 'confirmation',
      data: CBXDialogData,
      closeFn: (res) => this.onCloseDialog(res)
    })
  }
  onCloseDialog(res: any) {
    if (res) {
      this.popup = false;
      this.updatedProcessInfo = false;
      this.processInfo = this.stageCode = undefined;
      sessionStorage.removeItem('userId');
      this._userService.removeToken();
      this._router.navigate(this.closeNavigation);
    }
  }

  onCloseApprovalDialog(res:any) {
    if(res){
      this._router.navigate(['welcome']);
    }
  }

  fetchProcessInfo(): Observable<IProcessInfo> {
    const httpRequest = new HttpRequest();
    httpRequest.setResource('/processinfo/{processCode}/{processId}');
    httpRequest.addPathParameter('processCode', this.processCode);
    httpRequest.addPathParameter('processId', this.processId);
    httpRequest.setMethod('GET');
    httpRequest.setServerContext(environment.commonPublisher);

    return this._http.invokeRestApi(httpRequest).pipe(map((response: IHttpSuccessPayload<any>) => {
      this.updatedProcessInfo = true;
      this.processInfo = response?.body.processInfo;
      return this.processInfo
    },
      catchError((err: IHttpErrorPayload) => {
        return throwError(err)
      })));
  }

  handleBackNavigation() {
    if (!this._userService.getToken()) { console.log('edit not allowed for the previous screen'); return; }
    if (this.updatedProcessInfo) {
      this.setBackNavDetails(this.processInfo); return
    }
    else {
      this.fetchProcessInfo().subscribe(
        {
          next: (res) => {
            this.setBackNavDetails(res);
          },
          error: (error) => { }
        }
      )
    }

  }

  setBackNavDetails(processInfo: IProcessInfo) {
    let stageInfo = processInfo.stageInfo[processInfo.stageInfo.findIndex(obj => { return obj.stageCode == this.stageCode }) - 1];
    if (!stageInfo) stageInfo = processInfo.stageInfo[processInfo.stageInfo.length - 1];
    if (stageInfo.stageUIConfig.editAllowed != '1') {
      console.log('edit not allowed for the previous screen');
      return;
    }
    let routingParams = stageInfo.stageUIConfig.routingParam ? ((typeof (stageInfo.stageUIConfig.routingParam) === 'string') ? JSON.parse(stageInfo.stageUIConfig.routingParam) : stageInfo.stageUIConfig.routingParam) : {};

    this.setTitle(stageInfo.stageUIConfig.title);
    this.processCompleted = stageInfo.stageCompletionPercentage;
    let path = (stageInfo.stageUIConfig.navigationPath) ? stageInfo.stageUIConfig.navigationPath.split('/') : '';
    let routerPath = ['process-shell'].concat(path);

    routingParams['action'] = 'MODIFY';
    routingParams['processId'] = this.processId;
    routingParams['currentStage'] = this.stageCode = stageInfo.stageCode;
    routingParams['response'] = processInfo.processPayload.COB[stageInfo.stageCode];

    this.navToResult(routerPath, routingParams)
  }

  pushBackNav(navDetails) {
    this.backNavData.push(navDetails)
  }
  popBackNav(): any {
    return this.backNavData.pop();
  }

  getInitialProcess() {
    return this.draftProcess[0];
  }
  clearDraftProcess() {
    this.draftProcess = [];
  }

  updateShell() {
    if (this._shellRoutingParams && this._shellRoutingParams.processTitle) {
      this.processCode = this._shellRoutingParams.processCode;
      this.processTitle = this._shellRoutingParams.processTitle;
      this.formType = this._shellRoutingParams.formType || '2';

      if (this._commonService.isDesktop()) {
        if (["CREATEOTP", "VERIFYOTP"].indexOf(this.currentStage) >= 0) {
          this._commonService.isbackBtn = false;
        } else {
          this._commonService.isbackBtn = true;
        }
        this._commonService.searchRequired = true;
        this._commonService.serviceDescription = this.processTitle;
      }
    }
  }

  onFormDestory(formCtrl: any) {
    this._confirmationEnable = false;
    this.isConfirmationClicked = false;
    console.log('onFormDestory');
  }

  getResultLastPath(path: any) {
    switch (path) {
      case 'transfers-result-info':
        return 'transfers-result-info';
      case 'settings-result-info':
        return 'settings-result-info';
      case 'result-info':
        return this._commonService.isDesktop() ? 'result' : 'result-info';
      default:
        throw 'result-info';
    }
  }

  doShowCancel() {
    return (['CREATEOTP' ,'VERIFYOTP'].indexOf(this.currentStage) >= 0);
  }

  cancelProcess() {
    if (this.currentStage == 'CREATEOTP' || this.currentStage == 'VERIFYOTP') {
      this.stageCode = undefined;
      this.currentStage = "";
      this.clearDataForFailureEnd({ currentStage: "FailureEnd" });
      // let backNav = backNavData.backNavpath;
      // if (backNav.length > 0) {
      //   this.clearDataForFailureEnd({ currentStage: "FailureEnd" });
      //   if (this._commonService.isMobile()) {
      //     this._router.navigate(['process-shell', backNav?.[1], 'result-info'], {
      //       queryParams: {
      //         "title": "Failed Transaction",
      //         "message": "You have cancelled the request.",
      //         "currentStage": "FailureEnd",
      //         "backNavPath": backNav?.[1],
      //       },
      //       queryParamsHandling: 'preserve'
      //     });

      //   }
      //    else {
      //     let currentBasepath = this._router.url.split('/')[2];
      //     let routerPath=['process-shell', backNav?.[1], 'result-info'];
      //     routerPath = ['home', currentBasepath].concat(routerPath);
      //     this._router.navigate(routerPath, {
      //       queryParams: {
      //         "title": "Failed Transaction",
      //         "message": "You have cancelled the request.",
      //         "currentStage": "FailureEnd",
      //         "backNavPath": backNav?.[1],
      //       },
      //       queryParamsHandling: 'preserve'
      //     });
      //     // this._dialogService.open({
      //     //   component: 'result',
      //     //   data: {
      //     //     "title": "Failed Transaction",
      //     //     "message": "You've cancelled the request.",
      //     //     "currentStage": "FailureEnd",
      //     //     "backNavPath": backNav?.[1],
      //     //   },
      //     //   panelClass: 'result-page-dialog'
      //     // });
      //   }
      // }

      let CBXDialogData:any = {
        result:'failure',
        title: "Failed Transaction",
        message: "You have cancelled the request.",
        button: ['Close'],
      };
      this._dialogService.open({
        component: 'alert',
        data: CBXDialogData,
        closeFn: (res) => {
          this._router.navigate(['home','overview']);
        }
      });
    }
  }


  manualFetchProcessInstance(processCode: any,processId) {
    const httpRequest = new HttpRequest();
    httpRequest.setResource('/processinstance/{processCode}/{processId}');
    httpRequest.addPathParameter('processCode', processCode);
    httpRequest.addPathParameter('processId', processId);
    httpRequest.setMethod('GET');
    httpRequest.setServerContext(environment.commonPublisher);

    return this._http.invokeRestApi(httpRequest)
  }
}
